/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemTypeConstants } from '../../models/system-type-constants';

export interface ApiCtCoolingSystemGetCoolingTypeGet$Params {
  serialNumber: string;
  materialNumber: number;
}

export function apiCtCoolingSystemGetCoolingTypeGet(http: HttpClient, rootUrl: string, params: ApiCtCoolingSystemGetCoolingTypeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemTypeConstants>> {
  const rb = new RequestBuilder(rootUrl, apiCtCoolingSystemGetCoolingTypeGet.PATH, 'get');
  if (params) {
    rb.query('serialNumber', params.serialNumber, {});
    rb.query('materialNumber', params.materialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemTypeConstants>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
apiCtCoolingSystemGetCoolingTypeGet.PATH = '/api/CT/CoolingSystem/GetCoolingType';
apiCtCoolingSystemGetCoolingTypeGet.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
apiCtCoolingSystemGetCoolingTypeGet.ROOTURL = '/cooling';
